import script from "./base-detail.vue?vue&type=script&lang=ts"
export * from "./base-detail.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__